// MUS-607: windows 360 to 375 px wide (a phone held upright) are supported.
// Settings set its cards 600px wide and 50px in, its tab row on one line and
// its forms 350px wide, so the cards, the later tabs and the form fields ran
// past the right edge. That held in every window under 750px wide: measured,
// the Accessibility tab was cut up to 700px wide and the Settings pane
// scrolled sideways up to 744px (an iPad mini held upright, by 6px); from
// 768px everything fits. Below 750px the cards fill the window with a small
// margin, the tabs wrap and the forms shrink to fit. Wider windows keep the
// layout they had.
export const NARROW_SETTINGS_MAX_WIDTH_PX = 749.98;
export const NARROW_SETTINGS_QUERY = `@media (max-width: ${NARROW_SETTINGS_MAX_WIDTH_PX}px)`;
export const NARROW_SETTINGS_SIDE_PX = 12;

const narrowSide = `${NARROW_SETTINGS_SIDE_PX}px`;

export const settingsCardSx = {
  marginLeft: '50px',
  width: '600px',
  [NARROW_SETTINGS_QUERY]: {
    marginLeft: narrowSide,
    marginRight: narrowSide,
    width: 'auto',
  },
};

// The text inside a card sits 24px in from the card's edges.
export const settingsCardContentSx = {
  marginLeft: '24px',
  marginRight: '24px',
  [NARROW_SETTINGS_QUERY]: {
    marginLeft: '16px',
    marginRight: '16px',
  },
};

export const settingsTabRowSx = {
  display: 'flex',
  marginLeft: '50px',
  [NARROW_SETTINGS_QUERY]: {
    marginLeft: narrowSide,
    marginRight: narrowSide,
    flexWrap: 'wrap',
    rowGap: '4px',
  },
};

export const settingsFormSx = {
  width: '350px',
  maxWidth: '100%',
};

// The Practice tab's score theme preview is 500px wide with a 1px border.
// In a narrow window the card is narrower than that (about 300px inside at
// 360 wide), so the preview is drawn smaller by the share of its width the
// card has room for; where the card has room it is drawn as before.
export const SCORE_THEME_PREVIEW_OUTER_WIDTH_PX = 502;

export const scoreThemePreviewZoom = (roomPx: number): number =>
  roomPx > 0 ? Math.min(1, roomPx / SCORE_THEME_PREVIEW_OUTER_WIDTH_PX) : 1;
